export default __webpack_public_path__ + "static/media/ts-3-4.a9caefda.svg";